import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { ProfileManagerService } from '@app/custom-shared/services/profile-manager.service';

@Directive({
  selector: '[ifMasterClientBo]',
})
export class IfMasterClientBoDirective implements OnInit {
  constructor(
    private el: ElementRef,
    private profileService: ProfileManagerService,
  ) {}
  @Input('ifMasterClientBo') profile: boolean;
  ngOnInit() {
    this.el.nativeElement.style.display = 'none';

    if (this.profileService.isClientBo() && this.profile) {
      this.el.nativeElement.style.display = 'flex';
    }
  }
}
